if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.button = this.querySelector('.sticky-atc__button');
        this.buttonLabel = this.button.querySelector('span');
        this.titleTarget = this.querySelector('.sticky-atc__variant');
        this.priceTarget = this.querySelector('.sticky-atc__price');
        this.image = this.querySelector('.sticky-atc__image');

        this.sourceForm = document.querySelector('product-info product-form');
        this.sourceButton = this.sourceForm ? this.sourceForm.querySelector('[name="add"]') : null;
        if (!this.sourceButton) return;

        this.button.addEventListener('click', this.onButtonClick.bind(this));

        this.observer = new IntersectionObserver(this.onIntersection.bind(this), { threshold: 0 });
        this.observer.observe(this.sourceForm);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onButtonClick() {
        if (this.button.disabled) return;
        this.sourceButton.click();
      }

      onIntersection(entries) {
        const entry = entries[0];
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('sticky-atc--active', scrolledPast);
        this.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      }

      onVariantChange(event) {
        const variant = event && event.data ? event.data.variant : null;
        if (!variant) return;

        this.updatePrice(event.data.sectionId);
        this.updateVariantTitle(variant);
        this.updateImage(variant);
        this.updateButton();
      }

      updatePrice(sectionId) {
        const source = document.getElementById(`price-${sectionId}`);
        if (!source || !this.priceTarget) return;

        const onSale = source.querySelector('.price')?.classList.contains('price--on-sale');
        const priceItem = source.querySelector(onSale ? '.price-item--sale' : '.price-item--regular');
        if (priceItem) this.priceTarget.textContent = priceItem.textContent.trim();
      }

      updateVariantTitle(variant) {
        if (!this.titleTarget || !variant.title) return;
        this.titleTarget.textContent = variant.title;
      }

      updateImage(variant) {
        if (!this.image || !variant.featured_image || !variant.featured_image.src) return;

        const src = variant.featured_image.src;
        this.image.src = `${src}${src.includes('?') ? '&' : '?'}width=120`;
      }

      updateButton() {
        const disabled = this.sourceButton.hasAttribute('disabled');
        this.button.disabled = disabled;
        if (!this.buttonLabel) return;

        const sourceLabel = this.sourceButton.querySelector('span');
        this.buttonLabel.textContent =
          disabled && sourceLabel ? sourceLabel.textContent.trim() : this.button.dataset.defaultLabel;
      }
    }
  );
}
